
  <div class="title" [ngClass]="{'title-with-margin': titleWithMargin}">
      {{title}}
  </div>

  <app-highcharts
              [options]="optionsChart"
              [showValue]="true"
              [defaultChart]="true"
  >
  </app-highcharts> 

